// usePendingList — paginated pending-bookings list.
//
// Filters live in URL search params (CLIENT-DECISION-010). The hook is
// pure: it derives its query parameters from the supplied filter object
// and returns the list + pagination meta.

import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../api/client';
import { endpoints } from '../../../api/endpoints';
import { queryKeys } from '../../../api/queryKeys';
import type { FilterRecord } from '../../../api/queryKeys';
import type { PendingListResponse } from '../../../types/api';

export interface PendingFilters {
  q?: string;
  status?: 'pending' | 'final_notice' | 'booked' | 'cancelled';
  page: number;
  limit: number;
}

export function usePendingList(filters: PendingFilters) {
  const filterRecord: FilterRecord = { ...filters };
  return useQuery<PendingListResponse>({
    queryKey: queryKeys.pending.list(filterRecord),
    queryFn: async () => {
      const res = await apiClient.get<PendingListResponse>(endpoints.pending.list, {
        params: filters,
      });
      if (!res.data) throw new Error('Pending list response missing data');
      return res.data;
    },
    staleTime: 30_000,
  });
}
